import axios from 'axios'

const instance = axios.create({
    baseURL: '/suizhou_truck',
    timeout: 15000,
    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'},
    transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
    }]
});

function getHttp(http, params) {

    return new Promise(function(resolve, reject){
        instance.get(http, params)
            .then(function (response) {
                resolve(response)
            })
            .catch(function (error) {
                console.log(error)
                reject(error)
            })
    })

}

function postHttp(http, params) {

    return new Promise(function(resolve, reject){
        instance.post(http, params)
            .then(function (response) {
                resolve(response)
            })
            .catch(function (error) {
                console.log(error)
                reject(error)
            })
    })

}

export default function (type, http, params) {

    return new Promise(function(resolve, reject){

        switch (type) {
            case 'get':
                getHttp(http, params)
                    .then(function (res) {
                        resolve(res)
                    })
                break
            case 'post':
                postHttp(http, params)
                    .then(function (res) {
                        resolve(res)
                    })
                break
        }
    })

}